// extracted by mini-css-extract-plugin
module.exports = {"sign-advantage-items":"SignAdvantageItems_sign-advantage-items__OQWuU"};